import { NotificationModel } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { NotificationsFilters } from '@finxone-platform/form-action';
import { NotificationsStatusRequest, PaginationMeta } from '@finxone-platform/shared/sys-config-types';
import { PaymentRequestSummary } from '../state/notifications.state';

export class FetchNotifications {
  static readonly type = '[Notifications] FetchNotifications';
  constructor(
    public page = 1,
    public limit = 10,
    public filterType: NotificationsFilters = NotificationsFilters.All,
  ) {}
}

export class ProcessNotification {
  static readonly type = '[Notifications] ProcessNotification';
}
export class UpdateNotifications {
  static readonly type = '[Notifications] UpdateNotifications';
  constructor(
    public notificationList: NotificationModel[],
    public hasMore: boolean,
    public pagination: PaginationMeta,
  ) {}
}
export class SetNotificationLoadingStatus {
  static readonly type = '[Notifications] SetNotificationLoadingStatus';
  constructor(public isLoading: boolean) {}
}
export class SetPaymentRequestSummary {
  static readonly type = '[Notifications] SetPaymentRequestSummary';
  constructor(public paymentRequestSummary: PaymentRequestSummary) {}
}

export class SetPaymentRequestSummaryApprovedorRejectedDate {
  static readonly type = '[Notifications] SetPaymentRequestSummaryApprovedorRejectedDate';
  constructor(public date: string) {}
}

export class SetSelectedNotification {
  static readonly type = '[SelectedNotification] SetSelectedNotification';
  constructor(public selectedNotification: any) {}
}
export class ClearNotificationsCache {
  static readonly type = '[Notifications] ClearNotificationsCache';
}

export class UpdateNotificationStatus {
  static readonly type = '[Notifications] UpdateNotificationStatus';
  constructor(public notificationStatus: NotificationsStatusRequest) {}
}
